// DeskSelector.js
import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  CircularProgress
} from '@mui/material';
import { styled } from '@mui/material/styles';
import DeskIcon from '@mui/icons-material/Desk';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

// Styled components
const SectionHeading = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(2),
  color: theme.palette.text.primary
}));

const DeskSelector = ({
  loadingAvailability,
  spaces,
  setSpaces,
  availabilityInfo
}) => {
  return (
    <Paper elevation={0} variant="outlined" sx={{ p: 2, mb: 3, borderRadius: 1 }}>
      <SectionHeading variant="subtitle1">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DeskIcon />
          Number of Desks
        </Box>
      </SectionHeading>
      
      {loadingAvailability ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => spaces > 1 && setSpaces(spaces - 1)}
            disabled={spaces <= 1}
          >
            <RemoveIcon fontSize="small" />
          </Button>
          
          <Typography variant="h6" sx={{ minWidth: 40, textAlign: 'center' }}>
            {spaces}
          </Typography>
          
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              if (availabilityInfo && spaces < availabilityInfo.available) {
                setSpaces(spaces + 1);
              }
            }}
            disabled={!availabilityInfo || spaces >= availabilityInfo.available}
          >
            <AddIcon fontSize="small" />
          </Button>
          
          <Typography variant="body2" color="text.secondary">
            {availabilityInfo ? 
              `of ${availabilityInfo.available} available` : 
              'No availability data'}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default DeskSelector;